import React from 'react'
import Header from '../component/Header'
import HeroBanner from '../component/HeroBanner'
import Intro from '../component/Intro'
import KeyFeature from '../component/KeyFeature'
import Why from './Why'
import EmiCalculator from '../component/EmiCalculator'
import Faq from '../component/Faq'
import Loanpurpose from '../component/Loanpurpose'
import ServiceList from '../component/ServiceList'
import Loanpurposeother from '../component/Loanpurposeother'
import Steps from '../component/Steps'
import Footer from '../component/Footer'
import Partners from "../component/Partners"
// import Steps from '../component/Steps'
// import StatsSection from '../component/StatsSection'



export default function Home() {
  return (
    <>
      <Header />
      <HeroBanner />
      <Intro/>
      <Why/>
      <EmiCalculator/>
      <Steps/>
      <Loanpurpose/>
      <ServiceList/>
      <Partners/>
      
      <Loanpurposeother/>
      <Faq/>
      <Footer/>
      {/* <KeyFeature/> */}
      {/* <StatsSection/> */}
     
     
    </>
  )
}
